// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/currentUser */
export async function queryCurrentUser(options?: { [key: string]: any }) {
    return request<any>('/api/NewUser/index', {
        method: 'GET',
        ...(options || {}),
    });
}

/** 登录 */
export async function login(data: API_USER.LoginParams, options?: { [key: string]: any }) {
    return request<any>('/api/NewUser/login', {
        method: 'POST',
        data,
        ...(options || {}),
    });
}

/** 注册 */
export async function register(data: API_USER.RegisterParams, options?: { [key: string]: any }) {
    return request<any>('/api/NewUser/register', {
        method: 'POST',
        data,
        ...(options || {}),
    });
}

/** 忘记密码 */
export async function forgetPassword(data: API_USER.ForgetPasswordParams, options?: { [key: string]: any }) {
    return request<any>('/api/NewUser/forgetPassword', {
        method: 'POST',
        data,
        ...(options || {}),
    });
}

/** 退出登录 */
export async function logout(options?: { [key: string]: any }) {
    return request<any>('/api/user/logout', {
        method: 'GET',
        ...(options || {}),
    });
}
